import classnames from 'classnames'
import React from 'react'
import * as ReactStrap from 'reactstrap'
import './styles.css'

export const Input = ({showCursor = false, ...props}: ReactStrap.InputProps) =>
<div className={classnames('rasa-input', {cursor: showCursor})}>
  {props.label ? <label>{props.label}</label> : null}
  {props.required ? <label className="required">(Required)</label> : null}
  {props.description ? <label className="description">{props.description}</label> : null}
  <ReactStrap.Input {...props} />
  <i></i>
</div>
